import React from "react";
import { TodoPlaceholder } from "@cms/ui/components/todo-placeholder";

// TO-DO: Implement site detail view — deploy history, env vars, domain config, analytics.
export function ClientSiteDetailPage() {
  return (
    <TodoPlaceholder
      title="Site Details"
      description="Deployment history, environment variables, domain configuration, and per-site analytics. Requires site-level API endpoints."
    />
  );
}
